import { call, put, takeLatest, delay } from 'redux-saga/effects';
import * as types from './_actionTypes';
import * as actions from './_actions';
import CourseContentHelper from '../../../../utils/API/BackendHelper/admin/courseContent';
import ApiHelper from '../../../../utils/MUX/ApiHelper';

// Fetch course contents
function* fetchCourseContentsSaga(action) {
  try {
    const { courseId, params } = action.payload;
    
    console.log('Fetching course contents for courseId:', courseId, 'with params:', params);
    
    const response = yield call(CourseContentHelper.getCourseContents, courseId, params);
    
    console.log('Fetch course contents response:', response);
    
    if (response.success) {
      const contentsData = response.data || [];
      
      // Normalize the contents data to ensure consistent structure
      const contents = contentsData.map(content => ({
        id: content.id,
        course_id: content.course_id,
        title: content.title || '',
        type: content.type || 'video',
        content_url: content.content_url || '',
        content_data: content.content_data || null,
        duration_minutes: content.duration_minutes || 0,
        order_index: content.order_index || 0,
        is_mandatory: content.is_mandatory || false,
        created_at: content.created_at,
        updated_at: content.updated_at,
        created_by: content.created_by
      }));
      
      yield put(actions.fetchCourseContentsSuccess(contents));
    } else {
      yield put(actions.fetchCourseContentsFailure(response.message || 'Failed to fetch course contents'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchCourseContentsSaga:', error);
    yield put(actions.fetchCourseContentsFailure(error.message || 'An unexpected error occurred while fetching course contents'));
  }
}

// Fetch single course content
function* fetchCourseContentSaga(action) {
  try {
    const contentId = action.payload;
    
    console.log('Fetching course content with ID:', contentId);
    
    const response = yield call(CourseContentHelper.getCourseContent, contentId);
    
    console.log('Fetch course content response:', response);
    
    if (response.success) {
      const content = response.data;
      
      // Normalize single content
      const normalizedContent = {
        id: content.id,
        course_id: content.course_id,
        title: content.title || '',
        type: content.type || 'video',
        content_url: content.content_url || '',
        mux_playback_id: content.mux_playback_id || null,
        content_data: content.content_data || null,
        duration_minutes: content.duration_minutes || 0,
        order_index: content.order_index || 0,
        is_mandatory: content.is_mandatory || false,
        created_at: content.created_at,
        updated_at: content.updated_at,
        created_by: content.created_by
      };
      
      yield put(actions.fetchCourseContentSuccess(normalizedContent));
    } else {
      yield put(actions.fetchCourseContentFailure(response.message || 'Failed to fetch course content'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchCourseContentSaga:', error);
    yield put(actions.fetchCourseContentFailure(error.message || 'An unexpected error occurred while fetching course content'));
  }
}

// Create course content
function* createCourseContentSaga(action) {
  try {
    const { courseId, contentData } = action.payload;
    

    console.log('Creating course content for courseId:', courseId, 'with data:', contentData);
    
    const response = yield call(CourseContentHelper.createCourseContent, courseId, contentData);
    
    console.log('Create course content response:', response);
    
    if (response.success) {
      const content = response.data;
      
      // Normalize created content
      const normalizedContent = {
        id: content.id,
        course_id: content.course_id,
        title: content.title || '',
        type: content.type || 'video',
        content_url: content.content_url || '',
        mux_playback_id: content.mux_playback_id || null,
        content_data: content.content_data || null,
        duration_minutes: content.duration_minutes || 0,
        order_index: content.order_index || 0,
        is_mandatory: content.is_mandatory || false,
        created_at: content.created_at,
        updated_at: content.updated_at,
        created_by: content.created_by
      };
      
      yield put(actions.createCourseContentSuccess(normalizedContent));
      
      // Optionally refetch the course contents to update the list
      yield put(actions.fetchCourseContentsRequest(courseId));
    } else {
      yield put(actions.createCourseContentFailure(response.message || 'Failed to create course content'));
    }
  } catch (error) {
    console.error('Unexpected error in createCourseContentSaga:', error);
    yield put(actions.createCourseContentFailure(error.message || 'An unexpected error occurred while creating course content'));
  }
}

// Update course content
function* updateCourseContentSaga(action) {
  try {
    const { contentId, updateData } = action.payload;
    
    console.log('Updating course content with ID:', contentId, 'data:', updateData);
    
    const response = yield call(CourseContentHelper.updateCourseContent, contentId, updateData);
    
    console.log('Update course content response:', response);
    
    if (response.success) {
      const content = response.data;
      
      // Normalize updated content
      const normalizedContent = {
        id: content.id,
        course_id: content.course_id,
        title: content.title || '',
        type: content.type || 'video',
        content_url: content.content_url || '',
        content_data: content.content_data || null,
        duration_minutes: content.duration_minutes || 0,
        order_index: content.order_index || 0,
        is_mandatory: content.is_mandatory || false,
        created_at: content.created_at,
        updated_at: content.updated_at,
        created_by: content.created_by
      };
      
      yield put(actions.updateCourseContentSuccess(normalizedContent));
    } else {
      yield put(actions.updateCourseContentFailure(response.message || 'Failed to update course content'));
    }
  } catch (error) {
    console.error('Unexpected error in updateCourseContentSaga:', error);
    yield put(actions.updateCourseContentFailure(error.message || 'An unexpected error occurred while updating course content'));
  }
}

// Delete course content
function* deleteCourseContentSaga(action) {
  try {
    const contentId = action.payload;
    
    console.log('Deleting course content with ID:', contentId);
    
    const response = yield call(CourseContentHelper.deleteCourseContent, contentId);
    
    console.log('Delete course content response:', response);
    
    if (response.success) {
      yield put(actions.deleteCourseContentSuccess(contentId));
    } else {
      yield put(actions.deleteCourseContentFailure(response.message || 'Failed to delete course content'));
    }
  } catch (error) {
    console.error('Unexpected error in deleteCourseContentSaga:', error);
    yield put(actions.deleteCourseContentFailure(error.message || 'An unexpected error occurred while deleting course content'));
  }
}

// Reorder course contents
function* reorderCourseContentsSaga(action) {
  try {
    const { courseId, newOrder } = action.payload;
    
    console.log('Reordering course contents for courseId:', courseId, 'newOrder:', newOrder);
    
    const response = yield call(CourseContentHelper.reorderCourseContents, courseId, newOrder);
    
    console.log('Reorder course contents response:', response);
    
    if (response.success) {
      const contentsData = response.data || [];
      
      // Normalize reordered contents
      const contents = contentsData.map(content => ({
        id: content.id,
        course_id: content.course_id,
        title: content.title || '',
        type: content.type || 'video',
        content_url: content.content_url || '',
        content_data: content.content_data || null,
        duration_minutes: content.duration_minutes || 0,
        order_index: content.order_index || 0,
        is_mandatory: content.is_mandatory || false,
        created_at: content.created_at,
        updated_at: content.updated_at,
        created_by: content.created_by
      }));
      
      yield put(actions.reorderCourseContentsSuccess(contents));
    } else {
      yield put(actions.reorderCourseContentsFailure(response.message || 'Failed to reorder course contents'));
    }
  } catch (error) {
    console.error('Error in reorderCourseContentsSaga:', error);
    yield put(actions.reorderCourseContentsFailure(error.message || 'An unexpected error occurred while reordering course contents'));
  }
}

// Fetch course content statistics
function* fetchCourseContentStatsSaga(action) {
  try {
    const courseId = action.payload;
    
    console.log('Fetching content statistics for courseId:', courseId);
    
    const response = yield call(CourseContentHelper.getCourseContentStatistics, courseId);
    
    console.log('Fetch content statistics response:', response);
    
    if (response.success) {
      const stats = response.data || {
        total: 0,
        mandatory: 0,
        optional: 0,
        totalDuration: 0,
        byType: {}
      };
      
      yield put(actions.fetchCourseContentStatsSuccess(stats));
    } else {
      yield put(actions.fetchCourseContentStatsFailure(response.message || 'Failed to fetch content statistics'));
    }
  } catch (error) {
    console.error('Unexpected error in fetchCourseContentStatsSaga:', error);
    yield put(actions.fetchCourseContentStatsFailure(error.message || 'An unexpected error occurred while fetching content statistics'));
  }
}


function* uploadMuxVideoSaga(action) {
  try {
    // 1. Create upload URL from backend
    const response = yield call(ApiHelper.createDirectUpload);
    console.log('Create Direct Upload Response:', response);
    
    
    if (!response?.data?.url || !response?.data?.uploadId) {
      throw new Error('Invalid upload URL response from backend');
    }
    const uploadId = response.data.uploadId;

    // 2. Upload file to Mux upload URL
    // action.payload is the file itself, not action.payload.file
   yield call(ApiHelper.uploadToMux,  action.payload, response.data.url);

    let uploadStatus = 'waiting';
    let assetId = null;
    let attempts = 0;
    const maxAttempts = 30; // Max 30 attempts (5 minutes with 10s intervals)

    while (uploadStatus === 'waiting' && attempts < maxAttempts) {
      // yield delay(10000); // Wait 10 seconds before checking again

 console.log(`⏳ Checking upload status for uploadId: ${uploadId}, attempt ${attempts + 1}`);
      const statusResponse = yield call(ApiHelper.getUploadStatus, uploadId);
      console.log(`📊 Upload status check (attempt ${attempts + 1}):`, statusResponse.data);

      uploadStatus = statusResponse.data.status;
      assetId = statusResponse.data.assetId;

      attempts++;
    }

    // 4. Handle different upload statuses
    if (uploadStatus === 'asset_created' && assetId) {
      console.log('✅ Asset created successfully! Asset ID:', assetId);

      // Get asset details to retrieve playback ID
      const assetResponse = yield call(ApiHelper.getAsset, assetId);
      console.log('📹 Asset details:', assetResponse.data);

      const playbackId = assetResponse.data.playbackId

      if (!playbackId) {
        throw new Error('No playback ID found in asset');
      }

      // Dispatch success with playback ID
      yield put({ 
        type: types.UPLOAD_MUX_VIDEO_SUCCESS,
        payload: playbackId
      });

    } else if (uploadStatus === 'errored') {
      throw new Error('Mux video processing failed');
    } else if (uploadStatus === 'timed_out') {
      throw new Error('Upload timed out');
    } else if (uploadStatus === 'cancelled') {
      throw new Error('Upload was cancelled');
    } else {
      throw new Error('Upload status check timed out after 5 minutes');
    }

  } catch (error) {
    console.error('❌ Upload failed:', error);
    yield put({ 
      type: types.UPLOAD_MUX_VIDEO_FAILURE, 
      payload: error.message 
    });
  }

  
}



// Watcher saga
export default function* courseContentSaga() {
  yield takeLatest(types.FETCH_COURSE_CONTENTS_REQUEST, fetchCourseContentsSaga);
  yield takeLatest(types.FETCH_COURSE_CONTENT_REQUEST, fetchCourseContentSaga);
  yield takeLatest(types.CREATE_COURSE_CONTENT_REQUEST, createCourseContentSaga);
  yield takeLatest(types.UPDATE_COURSE_CONTENT_REQUEST, updateCourseContentSaga);
  yield takeLatest(types.DELETE_COURSE_CONTENT_REQUEST, deleteCourseContentSaga);
  yield takeLatest(types.REORDER_COURSE_CONTENTS_REQUEST, reorderCourseContentsSaga);
  yield takeLatest(types.FETCH_COURSE_CONTENT_STATS_REQUEST, fetchCourseContentStatsSaga);
  yield takeLatest(types.UPLOAD_MUX_VIDEO_REQUEST, uploadMuxVideoSaga);
}




























